import { MenuItem, Select } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { InsuranceTypeOptions } from 'src/config/insuranceTypeOptions'
import { setInsuranceType, useChoiceDispatch, useChoiceState } from '@context/ChoiceContext'
import useStyles, { selectMenu } from './styles'
import { analyticsEventSelectedInsurance } from 'src/services/analytics'
import { useTheme } from '@mui/material'

export const InsuranceTypeToAnalyticsMap: Record<InsuranceTypeOptions, string> = {
  [InsuranceTypeOptions.PRIVATE_INSURANCE]: 'private',
  [InsuranceTypeOptions.SOCIAL_INSURANCE]: 'statutory',
  [InsuranceTypeOptions.ADDITIONAL_PRIVATE_INSURANCE]: 'supplementary_insurance',
}

export const InsuranceTypeSelect = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { insuranceType } = useChoiceState()
  const dispatch = useChoiceDispatch()
  const insuranceValues = [
    { label: t('public_insurance_option'), value: InsuranceTypeOptions.SOCIAL_INSURANCE },
    { label: t('additional_private_insurance_option'), value: InsuranceTypeOptions.ADDITIONAL_PRIVATE_INSURANCE },
    { label: t('private_insurance_option'), value: InsuranceTypeOptions.PRIVATE_INSURANCE },
  ]
  const theme = useTheme()

  const handleInsuranceTypeChange = (newValue: InsuranceTypeOptions) => {
    dispatch(setInsuranceType(newValue))
    analyticsEventSelectedInsurance(InsuranceTypeToAnalyticsMap[newValue])
  }

  return (
    <Select
      className={classes.select}
      MenuProps={{
        style: selectMenu(theme),
      }}
      value={insuranceType}
      onChange={(e) => handleInsuranceTypeChange(e.target.value as InsuranceTypeOptions)}
    >
      {insuranceValues.map(({ label, value }) => (
        <MenuItem key={value} value={value} sx={selectMenu}>
          {label}
        </MenuItem>
      ))}
    </Select>
  )
}
